import React from 'react'
import { Button } from 'vnetwork-ui'
import AddIcons from '@/icons/AddIcons'
import { useTranslation } from 'react-i18next'
import { useModal } from '@/contexts/modal'
import { useParams } from 'react-router-dom'

interface CreateProps {}

const CreateComponent: React.FC<CreateProps> = ({}) => {
    const { id } = useParams()
    const { t } = useTranslation()
    const { setModal, open } = useModal()
    return (
        <Button
            size="small"
            variant="contained"
            startIcon={<AddIcons />}
            disabled={open}
            onClick={() => {
                setModal(
                    'CustomerModals/MailerModals/CreateCustomerMailerModal/index',
                    {
                        customerID: Number(id),
                    }
                )
            }}
        >
            {t('customers.mailers.create')}
        </Button>
    )
}

const Create = (props: CreateProps) => {
    return <CreateComponent {...props} />
}

export default Create
